var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('company-menu', {
    attrs: {
      "onLogout": _vm.logout,
      "companyId": _vm.companyId,
      "companyFullName": _vm.companyFullName
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-709d3fea","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/home/AppBar/CompanyMenuContainer.vue
// module id = 1175
// module chunks = 0